import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import urlJoin from 'url-join'
import WidthContainer from '../../../components/WidthContainer'

import Button from '../../../components/Button'

import illustration from '../images/illustration.svg'


const phoneBreakpoint = '@media only screen and (max-width: 800px)'

const RootContainer = styled(WidthContainer)`
`

const TextContainer = styled.div`
	max-width: 24rem;
`

const InnerContainer = styled.div`
	display: flex;
	margin: -2rem;
	
	> * {
		margin: 2rem;
	}
	
	${phoneBreakpoint} {
		flex-direction: column-reverse;
		align-items: center;
	}
`

const Column = styled.div`
	flex: 1;
`

const Title = styled.h1`
`

const Text = styled.div`
	margin: 2.5rem 0 1.125rem;
`

const Illustration = styled.img`
	${phoneBreakpoint}{
		max-width: 25rem;
	}
	width: 100%;
`

Illustration.defaultProps = {
	src: illustration,
	alt: '',
}

function IntroSection({className, data}) {
	return <RootContainer className={className}>
		<InnerContainer>
			<Column>
				<TextContainer>
					<Title>{data.title}</Title>
					<Text>{data.text}</Text>
					<Button to={urlJoin(data.url, '#list')}>{data.scrollButtonLabel}</Button>
				</TextContainer>
			</Column>
			<Column>
				<Illustration/>
			</Column>
		</InnerContainer>
	</RootContainer>
}

IntroSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		title: PropTypes.string.isRequired,
		text: PropTypes.string.isRequired,
		scrollButtonLabel: PropTypes.string.isRequired,
		url: PropTypes.string.isRequired,
	}).isRequired,
}

IntroSection.defaultProps = {
	className: '',
}

export default IntroSection
